const defaultContactEditorConfig = {
  initialContent: {
    title: "",
    contact_name: "",
    contact_email: "",
    contact_phone_label: "Text Message Number",
    contact_phone: "",
    intro_text: "",
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}) {
    return {
      title: templateState.title?.trim() || "",
      contact_name: templateState.contact_name?.trim() || "",
      contact_email: templateState.contact_email?.trim() || "",
      contact_phone_label:
        templateState.contact_phone_label?.trim() || "Text Message Number",
      contact_phone: templateState.contact_phone?.trim() || "",
      intro_text: templateState.intro_text?.trim() || "",
    };
  },

  getStep2Props({ templateState, setTemplateField }) {
    return {
      templateState,
      setTemplateField,
    };
  },
};

export default defaultContactEditorConfig;